import moment from 'moment';
import qs from 'qs';
import { HOME_PAGE_URL, MY_REWARDS_PAGE_URL, WEB_SHARE_CONTENT } from '../constants/gamesConstants';

const objectToString = Object.prototype.toString;
export const isString = v => objectToString.call(v) === '[object String]';
export const isNumber = v => objectToString.call(v) === '[object Number]';
export const isBoolean = v => objectToString.call(v) === '[object Boolean]';
export const isUndefined = v => objectToString.call(v) === '[object Undefined]';
export const isNull = v => objectToString.call(v) === '[object Null]';
export const isSymbol = v => objectToString.call(v) === '[object Symbol]';
export const isObject = v => objectToString.call(v) === '[object Object]';
export const isArray = v => objectToString.call(v) === '[object Array]';
export const isFunction = v => objectToString.call(v) === '[object Function]';

export function getIsAppFlag(location = {}) {
  const { search = '' } = location;
  const isAppsFlag = qs.parse(search, { ignoreQueryPrefix: true }).isAppsFlag;

  if (isAppsFlag === 'true') {
    return true;
  } else if (isAppsFlag instanceof Array && isAppsFlag[isAppsFlag.length - 1] === 'true') {
    return true;
  }
  return false;
}

export function getDeviceType(isAppsFlag = false, deviceType = '') {
  return isAppsFlag ? 'app' : deviceType === 'website' ? 'website' : 'msite';
}

export function getWindowInnerHeight(winObj) {
  const { innerHeight = '100vh' } = winObj || {};
  return innerHeight === '100vh' || innerHeight <= 500 ? '100vh' : `${innerHeight}px`;
}

export function setupCtaInterceptor(platform = 'msite') {
  return function ctaInterceptors(action) {
    const { type: actionType = '', data = '' } = action || {};
    const androidFuncAvaStatus = typeof GamificationAndroidJSBridge || '';
    const { webkit: { messageHandlers = '' } = {} } = window;
    try {
      switch (actionType) {
        case 'EXIT_GAME':
          if (platform === 'app') {
            androidFuncAvaStatus !== 'undefined' ? GamificationAndroidJSBridge.exitGame() : '';
            messageHandlers ? messageHandlers.exitGame.postMessage('') : '';
            return;
          }
          window.location = HOME_PAGE_URL;
          break;
        case 'REDIRECT_TO_MYREWARDS_PAGE':
          if (platform === 'app') {
            androidFuncAvaStatus !== 'undefined'
              ? GamificationAndroidJSBridge.openMyRewards(MY_REWARDS_PAGE_URL)
              : '';
            messageHandlers ? messageHandlers.openMyRewards.postMessage(MY_REWARDS_PAGE_URL) : '';
            return;
          }
          window.location = MY_REWARDS_PAGE_URL;
          break;
        case 'VIEW_APPLICABLE_PRODUCTS':
          if (platform === 'app') {
            androidFuncAvaStatus !== 'undefined'
              ? GamificationAndroidJSBridge.viewApplicableProducts(data)
              : '';
            messageHandlers ? messageHandlers.viewApplicableProducts.postMessage(data) : '';
            return;
          }
          platform === 'website' ? window.open(data) : (window.location = data);
          break;
        case 'VIEW_TERMS_AND_CONDITIONS':
          if (platform === 'app') {
            androidFuncAvaStatus !== 'undefined' ? GamificationAndroidJSBridge.viewTC(data) : '';
            messageHandlers ? messageHandlers.viewTC.postMessage(data) : '';
            return;
          }
          platform === 'website' ? window.open(data) : (window.location = data);
          break;
        case 'OPEN_HOME_PAGE':
          if (platform === 'app') {
            androidFuncAvaStatus !== 'undefined' ? GamificationAndroidJSBridge.openHomePage() : '';
            messageHandlers ? messageHandlers.openHomePage.postMessage('') : '';
            return;
          }
          window.location = HOME_PAGE_URL;
          break;
        case 'OPEN_AJIO_WALLET_PAGE':
          if (platform === 'app') {
            androidFuncAvaStatus !== 'undefined'
              ? GamificationAndroidJSBridge.openAjioWallet()
              : '';
            messageHandlers ? messageHandlers.openAjioWallet.postMessage('') : '';
            return;
          }
          platform === 'website' ? window.open(data) : (window.location = data);
          break;
        case 'COPY_COUPON_CODE':
          if (platform === 'app') {
            androidFuncAvaStatus !== 'undefined'
              ? GamificationAndroidJSBridge.copyCouponCode(data)
              : '';
            messageHandlers ? messageHandlers.copyCouponCode.postMessage(data) : '';
            return;
          }
          break;
        case 'WEB_SHARE':
          if (platform === 'app') {
            const { title = '', gameUrl = '', imageUrl = '' } = data || {};
            androidFuncAvaStatus !== 'undefined'
              ? GamificationAndroidJSBridge.initShare(title, gameUrl, imageUrl)
              : '';
            messageHandlers ? messageHandlers.initShare.postMessage(title, gameUrl, imageUrl) : '';
          }
          break;
        default:
          break; // do nothing
      }
    } catch (e) {
      console.log('App intcptr caught error');
    }
  };
}

export function converEpochDateWithFormat(dateValue, format = '') {
  const dValue = Object.prototype.toString.call(dateValue) === '[object Number]' ? dateValue : '';
  let startTime = '';
  let endTime = '';
  if (dValue) {
    switch (format) {
      case 'DD MMM YYYY':
        return moment(dValue).format('DD MMM YYYY');
      case 'TIME_OBJECT': {
        if (!dValue || !isNumber(dValue)) return { hours: '', minutes: '', seconds: '' };
        startTime = moment();
        endTime = moment(dateValue);
        const dif = moment.duration(endTime.diff(startTime));
        return {
          hours: dif.hours(),
          minutes: dif.minutes(),
          seconds: dif.seconds()
        };
      }
      case 'DIFF_IN_DAYS':
        startTime = moment();
        endTime = moment(dateValue);
        return endTime.diff(startTime, 'days');
      default:
        return moment(dValue).format('DD MMM YYYY');
    }
  }
  return '';
}

export async function createWebShareImageObject(platform = 'msite') {
  if (platform !== 'website') {
    const { imageName, imageUrl, mimeType } = WEB_SHARE_CONTENT;
    try {
      const response = await fetch(imageUrl);
      const data = await response.blob();
      const fileObj = new File([data], imageName, { type: mimeType });
      return [fileObj];
    } catch (e) {
      console.log('wb shr img ftch cgt err');
      return [];
    }
  }
  return null;
}

export function getRequestQueryParameterValueAtNode(req = {}, qName = '') {
  const { query: queryObj = {} } = req || {};
  const qValue = queryObj[qName] || '';

  if (typeof qValue === 'string') {
    return decodeURIComponent(qValue)
      .replace(/ {2,}/gi, ' ')
      .trim();
  } else if (qValue instanceof Array) {
    return decodeURIComponent(qValue[qValue.length - 1])
      .replace(/ {2,}/gi, ' ')
      .trim();
  } else {
    return '';
  }
}

export function getGameTypeAtNode(req = {}) {
  const { params: { gameType = '' } = {} } = req || {};

  if (
    (typeof gameType === 'string' && (gameType === 'undefined' || gameType.trim().length === '')) ||
    typeof gameType !== 'string'
  ) {
    return '';
  }
  return gameType;
}

export function getIsAppFlagAtNode(req = {}) {
  const v = getRequestQueryParameterValueAtNode(req, 'isAppsFlag').toLowerCase();
  return v === 'true';
}

export function getGameNameAtNode(req = {}) {
  const v = getRequestQueryParameterValueAtNode(req, 'gameName');
  return v || '';
}
